import Animations  from '../library/Animations';

window.addEventListener('preloader-done', () => {
	let animations  = new Animations('.animation', 'animated');

	// console.log('%c JavaScript entry file: /wp-content/themes/template/res/js/modules/Main.js ', 'background: #222; color: #bada55');
});


var $j = jQuery.noConflict();

$j(document).ready(function(){

	$j('#burger').click(function(){
		$j('.burger').toggleClass('is-active');
		$j('body').toggleClass('nav-open');
		setTimeout(function(){
			$j('#main_menu').toggleClass('nav-open--done');
		},700);
	});

	$j('#burger__inner').click(function(){
		$j('#main_menu').toggleClass('nav-open--done');
		setTimeout(function(){
			$j('.burger').toggleClass('is-active');
			$j('body').toggleClass('nav-open');
		},700);
	});

	$j('#btn_en').click(function(){
		$j('#btn_en').addClass('active');
		$j('#btn_de').removeClass('active');

		$j('#interview_de').fadeOut();
		setTimeout(function(){
			$j('#interview_en').fadeIn();
		},250);
	});

	$j('#btn_de').click(function(){
		$j('#btn_de').addClass('active');
		$j('#btn_en').removeClass('active');

		$j('#interview_en').fadeOut();
		setTimeout(function(){
			$j('#interview_de').fadeIn();
		},250);
	});



});


;/*SIMPLE AUDIO PLAYER*/(function() {
  // https://stackoverflow.com/a/34487069/383904
  var AUD = document.createElement("audio"),
      BTN = document.querySelectorAll("[data-audio]"),
      tot = BTN.length;

  function playPause() {
    // Get track URL from clicked element's data attribute
    var src = this.dataset.audio;
    // Are we already listening that track?
    if(AUD.src != src) AUD.src = src;
    // Toggle audio play() / pause() methods
    AUD[AUD.paused ? "play" : "pause"]();
    // Remove active class from all other buttons
    for(var j=0;j<tot;j++) if(BTN[j]!=this) BTN[j].classList.remove("on");
    // Add active class to clicked button
    this.classList.toggle("on");
    // Track ended? (Remove active class etc)
    AUD.addEventListener("ended", playPause);
  }

  for(var i=0;i<tot;i++) BTN[i].addEventListener("click", playPause);

}());



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Main.js